"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CheckboxGroup = void 0;
var _CheckboxGroup = require("./CheckboxGroup.styles");
var _ = require("../");
var _types = require("../../../utilities/types");
var _jsxRuntime = require("react/jsx-runtime");
var CheckboxGroup = function CheckboxGroup(props) {
  var children = props.children;
  var childrenToCheck = Array.isArray(children) ? children : [children];
  (0, _types.validateChildren)(childrenToCheck, [_.Checkbox], 'CheckboxGroup: Children must be of type Checkbox');
  var styles = (0, _CheckboxGroup.useStyles)(props);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: styles['cc-CheckboxGroup'],
    children: children
  });
};
exports.CheckboxGroup = CheckboxGroup;